import React from "react";

import { Card } from "antd";
import moment from "moment";

import { placeholder } from "@/lib/imageIcon";

const News = ({ stockNews, index }) => {
  const data = stockNews?.url?.split("/");

  return (
    <>
      <Card className="news-card-box" key={index + 1}>
        <div className="news-box-data">
          <div className="news-top-header">
            <div className="news-logo-box"></div>
            <div className="news-header-box">
              <div className="news-company-box">
                <div className="d-flex align-items-center gap-2">
                  <img
                    alt="Image"
                    src={`https://${data[2]}/favicon.ico`}
                    width={24}
                    height={24}
                    className="br-4"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = stockNews?.image || placeholder;
                    }}
                  />
                  <p className="news-title">{stockNews?.title}</p>
                </div>
                <p className="news-date">
                  {moment(stockNews?.publishedDate).format("YYYY-MM-DD")}
                </p>
              </div>
            </div>
          </div>
          <div>
            <p className="news-desc">{stockNews?.text}</p>
          </div>
        </div>
      </Card>
    </>
  );
};

export default News;
